import React, { useState } from 'react';
import { useI18n } from '../../hooks/useI18n';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import { PhoneForm } from './PhoneForm';
import { OtpForm } from './OtpForm';
import { ResetPasswordForm } from './ResetPasswordForm';
import { SetNewPasswordForm } from './SetNewPasswordForm';
import { CabinetHeader } from '../layout/CabinetHeader';

type AuthView = 'phone' | 'otp' | 'login' | 'register' | 'reset-password' | 'set-new-password' | 'thanks';

export const AuthShell: React.FC = () => {
  const { t, lang, setLang } = useI18n();

  // Check URL for reset password action
  const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
  const actionParam = searchParams.get('action');
  const initialView: AuthView = actionParam === 'set_new_password' ? 'set-new-password' : 'phone';
  
  const [view, setView] = useState<AuthView>(initialView);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otpContext, setOtpContext] = useState<'login' | 'register'>('login');
  
  const [resetKey] = useState(searchParams.get('reset_key') || '');
  const [resetLogin] = useState(searchParams.get('reset_login') || '');

  const handlePhoneSuccess = (phone: string) => {
    setPhoneNumber(phone);
    setOtpContext('login');
    setView('otp');
  };

  /**
   * Фаза 3.2: Після submit RegisterForm — перехід до OTP з context='register'.
   */
  const handleRegisterPhoneSuccess = (phone: string) => {
    setPhoneNumber(phone);
    setOtpContext('register');
    setView('otp');
  };

  return (
    <div className="cab-screen-wrap">
      {/* {renderHeader()} */}
      <CabinetHeader />
      
      {view === 'phone' && (
        <PhoneForm 
          onSuccess={handlePhoneSuccess}
          onEmailClick={() => setView('login')}
          onRegisterClick={() => setView('register')}
        />
      )}

      {view === 'otp' && (
        <OtpForm 
          phone={phoneNumber}
          onChangeNumber={() => setView('phone')}
          context={otpContext}
        />
      )}

      {view === 'login' && (
        <LoginForm 
          onRegisterClick={() => setView('register')}
          onPhoneClick={() => setView('phone')}
          onResetClick={() => setView('reset-password')}
        />
      )}
      
      {view === 'register' && (
        <RegisterForm 
          onLoginClick={() => setView('phone')}
          onSuccess={handleRegisterPhoneSuccess}
        />
      )}

      {view === 'reset-password' && (
        <ResetPasswordForm 
          onBack={() => setView('login')}
        />
      )}

      {view === 'set-new-password' && (
        <SetNewPasswordForm 
          resetKey={resetKey}
          login={resetLogin}
        />
      )}

      {view === 'thanks' && (
        <div className="cab-auth-form">
          <h2>{t('auth_ready') || 'Gotowe!'}</h2>
          <p className="cab-sub">{t('auth_redirect_msg') || 'Konto zostało założone pomyślnie. Za chwilę zostaniesz przekierowany...'}</p>
        </div>
      )}
    </div>

    
  );
};
